import { render, staticRenderFns } from "./VehicleCategoryList.html?vue&type=template&id=24cf2852&"
import script from "./VehicleCategoryList.vue?vue&type=script&lang=js&"
export * from "./VehicleCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports